import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { PATH_DASHBOARD } from '@/routes/paths';
import Performance from '@/components/icons/Performance';
import { BRANDS_ADD_BRAND, BRANDS_CURRENCY_OVERRIDE_VIEW, CATALOG_ADD_OFFER, CATALOG_CHANGE_OFFER, CATALOG_VIEW_BUNDLE, CATALOG_VIEW_OFFER, CATALOG_VIEW_PRODUCT, CMS_VIEW_PROVIDER, COMMISSION_ADD_PAYIN, COMMISSION_CHANGE_PAYIN, COMMISSION_VIEW_PAYIN, CUSTOMER_SERVICE_VIEW_PROVIDER, DISCOUNTS_VIEW_DISCOUNT_CODE, FULFILLMENT_VIEW_PROVIDER, MARKETING_EMAIL_VIEW_PROVIDER, MARKETING_PARTNER_MANAGE, ORDER_VIEW_ORDER, ORDER_VIEW_REPORT, PAYMENTS_VIEW_PROVIDER, TAX_VIEW_TAXREGION, USERS_VIEW_USER, WAREHOUSES_ADD_PROVIDER, WAREHOUSES_CHANGE_PROVIDER, WAREHOUSES_VIEW_PROVIDER } from '@/utils/enums/userPermissions';
import ShoppingBag from '@/components/icons/ShoppingBag';
import CliboardIcon from '@/components/icons/Clipboard';
import Lan from '@/components/icons/Lan';
import PriceTag from '@/components/icons/PriceTag';
import FilterIcon from '@/components/icons/FilterIcon';
import BoxIcon from '@/components/icons/BoxIcon';
import UserIcon from '@/components/icons/User';
import GearIcon from '@/components/icons/Gear';
import Crown from '@/components/icons/Crown';
import Building from '@/components/icons/Building';
import Payments from '@/components/icons/Payments';
import { useGetAllPaymentProvidersQuery } from '@/redux/slices/paymentsSlice';
import { getStripeAccountNumber } from '@/utils/payment-provider-utils';
import Support from '@/components/icons/Support';
import Discount from '@/components/icons/Discount';
import CommissionsIcon from '@/components/icons/CommissionsIcon';
import { ACCOUNTING_TAB } from '@/utils/enums/featureFlags';
const useNavigation = props => {
  const $ = _c(52);
  const pathname = usePathname();
  const currentBrand = useSelector(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !props?.fetchProviders;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      skip: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: providers
  } = useGetAllPaymentProvidersQuery(t0, t2);
  let t3;
  if ($[3] !== currentBrand || $[4] !== providers) {
    t3 = getStripeAccountNumber(providers, currentBrand);
    $[3] = currentBrand;
    $[4] = providers;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isAccountComplete = !!t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      title: "Performance",
      path: PATH_DASHBOARD.performance.root,
      icon: <Performance />,
      accessPermission: ORDER_VIEW_REPORT
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ShoppingBag />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      title: "Orders",
      path: PATH_DASHBOARD.orders.root,
      icon: t5,
      accessPermission: ORDER_VIEW_ORDER,
      subroutes: [{
        path: PATH_DASHBOARD.orders.root,
        accessPermission: [],
        isSubroute: true,
        redirectOnBrandChange: PATH_DASHBOARD.orders.root
      }]
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CliboardIcon />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      title: "Products",
      path: PATH_DASHBOARD.products.root,
      icon: t7,
      accessPermission: CATALOG_VIEW_PRODUCT,
      subroutes: [{
        path: PATH_DASHBOARD.products.root,
        accessPermission: [],
        isSubroute: true,
        redirectOnBrandChange: PATH_DASHBOARD.products.root
      }]
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Lan />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      title: "Bundles",
      path: PATH_DASHBOARD.bundles.root,
      icon: t9,
      accessPermission: CATALOG_VIEW_BUNDLE,
      subroutes: [{
        path: PATH_DASHBOARD.bundles.root,
        accessPermission: [],
        isSubroute: true,
        redirectOnBrandChange: PATH_DASHBOARD.bundles.root
      }]
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      title: "Offers",
      path: PATH_DASHBOARD.offers.root,
      subroutes: [{
        path: PATH_DASHBOARD.offers.root,
        accessPermission: [CATALOG_VIEW_OFFER, CATALOG_ADD_OFFER, CATALOG_CHANGE_OFFER],
        isSubroute: true,
        redirectOnBrandChange: PATH_DASHBOARD.offers.root
      }],
      icon: <PriceTag />,
      accessPermission: CATALOG_VIEW_OFFER
    };
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      title: "Discounts",
      path: PATH_DASHBOARD.discounts.root,
      icon: <Discount />,
      accessPermission: DISCOUNTS_VIEW_DISCOUNT_CODE
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FilterIcon />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      title: "Funnels",
      path: process.env.GU_FUNNELS_URL,
      target: "_blank",
      icon: t13,
      accessPermission: CMS_VIEW_PROVIDER,
      envs: ["partner.giddyup.io"]
    };
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      title: "Shipping",
      path: PATH_DASHBOARD.shipping.root,
      subroutes: [{
        path: PATH_DASHBOARD.shipping.warehouses.root,
        accessPermission: [WAREHOUSES_ADD_PROVIDER, WAREHOUSES_CHANGE_PROVIDER, WAREHOUSES_VIEW_PROVIDER],
        isSubroute: true,
        redirectOnBrandChange: PATH_DASHBOARD.shipping.root
      }],
      icon: <BoxIcon />,
      accessPermission: [WAREHOUSES_VIEW_PROVIDER]
    };
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      title: "Users",
      path: PATH_DASHBOARD.users.root,
      icon: <UserIcon />,
      accessPermission: USERS_VIEW_USER
    };
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      title: "Brands",
      path: PATH_DASHBOARD.brands.create,
      hidden: true,
      icon: <Building />,
      accessPermission: BRANDS_ADD_BRAND
    };
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      title: "Commissions",
      path: PATH_DASHBOARD.commissions.root,
      subroutes: [{
        path: PATH_DASHBOARD.commissions.root,
        accessPermission: [COMMISSION_ADD_PAYIN, COMMISSION_CHANGE_PAYIN, COMMISSION_VIEW_PAYIN],
        isSubroute: true,
        redirectOnBrandChange: PATH_DASHBOARD.commissions.root
      }],
      icon: <CommissionsIcon />,
      accessPermission: COMMISSION_VIEW_PAYIN
    };
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Payments />;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  const t20 = !isAccountComplete;
  let t21;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      flag: ACCOUNTING_TAB,
      showWhen: false
    };
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  let t22;
  if ($[23] !== t20) {
    t22 = {
      title: "Accounting",
      path: PATH_DASHBOARD.payments.root,
      icon: t19,
      accessPermission: ORDER_VIEW_REPORT,
      hidden: t20,
      featureGate: t21
    };
    $[23] = t20;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  let t24;
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = [{
      path: PATH_DASHBOARD.accounting.root,
      accessPermission: [ORDER_VIEW_REPORT],
      isSubroute: true
    }];
    t24 = [{
      title: "Financial Summary",
      path: PATH_DASHBOARD.accounting.financialSummary.salesOverview,
      activePath: PATH_DASHBOARD.accounting.financialSummary.root
    }, {
      title: "Payouts",
      path: PATH_DASHBOARD.accounting.payouts.overview,
      activePath: PATH_DASHBOARD.accounting.payouts.root
    }];
    t25 = <Payments />;
    $[25] = t23;
    $[26] = t24;
    $[27] = t25;
  } else {
    t23 = $[25];
    t24 = $[26];
    t25 = $[27];
  }
  const t26 = !isAccountComplete;
  let t27;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      flag: ACCOUNTING_TAB,
      showWhen: true
    };
    $[28] = t27;
  } else {
    t27 = $[28];
  }
  let t28;
  if ($[29] !== t26) {
    t28 = {
      title: "Accounting",
      path: PATH_DASHBOARD.accounting.financialSummary.salesOverview,
      subroutes: t23,
      children: t24,
      icon: t25,
      accessPermission: ORDER_VIEW_REPORT,
      hidden: t26,
      featureGate: t27
    };
    $[29] = t26;
    $[30] = t28;
  } else {
    t28 = $[30];
  }
  let t29;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      path: PATH_DASHBOARD.settings.brand.root,
      accessPermission: [],
      isSubroute: true
    };
    $[31] = t29;
  } else {
    t29 = $[31];
  }
  let t30;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      path: PATH_DASHBOARD.settings.currencies.root,
      accessPermission: [BRANDS_CURRENCY_OVERRIDE_VIEW],
      isSubroute: true
    };
    $[32] = t30;
  } else {
    t30 = $[32];
  }
  let t31;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      path: PATH_DASHBOARD.settings.taxes.root,
      accessPermission: [TAX_VIEW_TAXREGION],
      isSubroute: true
    };
    $[33] = t31;
  } else {
    t31 = $[33];
  }
  let t32;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      path: PATH_DASHBOARD.settings.payment.root,
      accessPermission: [PAYMENTS_VIEW_PROVIDER],
      isSubroute: true
    };
    $[34] = t32;
  } else {
    t32 = $[34];
  }
  let t33;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      path: PATH_DASHBOARD.settings.integrations.root,
      accessPermission: [FULFILLMENT_VIEW_PROVIDER, MARKETING_EMAIL_VIEW_PROVIDER, CUSTOMER_SERVICE_VIEW_PROVIDER],
      isSubroute: true
    };
    $[35] = t33;
  } else {
    t33 = $[35];
  }
  let t34;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      path: PATH_DASHBOARD.settings.email.root,
      isSubroute: true,
      accessPermission: [MARKETING_EMAIL_VIEW_PROVIDER],
      redirectOnBrandChange: PATH_DASHBOARD.settings.integrations.root
    };
    $[36] = t34;
  } else {
    t34 = $[36];
  }
  let t35;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = {
      path: PATH_DASHBOARD.settings.fulfillment.root,
      isSubroute: true,
      accessPermission: [FULFILLMENT_VIEW_PROVIDER],
      redirectOnBrandChange: PATH_DASHBOARD.settings.integrations.root
    };
    $[37] = t35;
  } else {
    t35 = $[37];
  }
  let t36;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      title: "Settings",
      path: PATH_DASHBOARD.settings.brand.root,
      subroutes: [t29, t30, t31, t32, t33, t34, t35, {
        path: PATH_DASHBOARD.settings.supportProviders.root,
        isSubroute: true,
        accessPermission: [CUSTOMER_SERVICE_VIEW_PROVIDER],
        redirectOnBrandChange: PATH_DASHBOARD.settings.integrations.root
      }],
      icon: <GearIcon />,
      accessPermission: []
    };
    $[38] = t36;
  } else {
    t36 = $[38];
  }
  let t37;
  let t38;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Support />;
    t38 = [];
    $[39] = t37;
    $[40] = t38;
  } else {
    t37 = $[39];
    t38 = $[40];
  }
  let t39;
  if ($[41] !== pathname) {
    t39 = {
      title: "Support",
      path: pathname,
      onClick: _temp2,
      id: "intercom_custom_launcher",
      icon: t37,
      accessPermission: t38
    };
    $[41] = pathname;
    $[42] = t39;
  } else {
    t39 = $[42];
  }
  let t40;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <Crown />;
    $[43] = t40;
  } else {
    t40 = $[43];
  }
  let t41;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = {
      path: PATH_DASHBOARD.mptools.domains.root,
      accessPermission: [],
      isSubroute: true
    };
    $[44] = t41;
  } else {
    t41 = $[44];
  }
  let t42;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = {
      title: "MP Tools",
      path: PATH_DASHBOARD.mptools.domains.root,
      icon: t40,
      isMPOption: true,
      subroutes: [t41, {
        path: PATH_DASHBOARD.mptools.externalSubdomains.root,
        accessPermission: [],
        isSubroute: true
      }],
      accessPermission: MARKETING_PARTNER_MANAGE
    };
    $[45] = t42;
  } else {
    t42 = $[45];
  }
  let t43;
  if ($[46] !== t22 || $[47] !== t28 || $[48] !== t39) {
    t43 = [t4, t6, t8, t10, t11, t12, t14, t15, t16, t17, t18, t22, t28, t36, t39, t42];
    $[46] = t22;
    $[47] = t28;
    $[48] = t39;
    $[49] = t43;
  } else {
    t43 = $[49];
  }
  const navConfig = t43;
  let t44;
  if ($[50] !== navConfig) {
    t44 = {
      navConfig
    };
    $[50] = navConfig;
    $[51] = t44;
  } else {
    t44 = $[51];
  }
  return t44;
};
export default useNavigation;
function _temp(state) {
  return state.brandSlice.currentBrand;
}
function _temp2() {}